export default {
  getPrjDate: (state) => state.prjDate,
};
